import { useGetInventoryImage } from "@/api/useInventory"
import { ASCENDING, ORDER_BY, SEEN_TIMESTAMP } from "@/helpers/filters.helper"
import { useQueryString } from "@/hooks/useQueryString"
import { getImageTabData } from "./useImageInventory.selector"

type Config = { enabled: boolean }

export const useImageInventory = (
  paramKeys?: { key: string }[],
  config?: Config
) => {
  const keys = [ORDER_BY, ASCENDING, SEEN_TIMESTAMP, ...(paramKeys || [])]
  const params = useQueryString(keys)
  const context = useGetInventoryImage(params, {
    select: getImageTabData,
    ...(config || {})
  })

  return context
}
